module.exports = __webpack_public_path__ + "static/media/logo-white.acc144ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo-white.png
// module id = 1054
// module chunks = 0